import { faIdCard, faSignOut, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown } from "antd";
import AppPaths from "constants/appPaths";
import { useAppSelector } from "hooks";
import { useHistory } from "react-router";

interface IUserProfileMenuProps {
    onLogout: () => void;
}

export default function UserProfileMenu({ onLogout }: IUserProfileMenuProps) {
    const history = useHistory();
    const tenant = useAppSelector((state) => state.userLogin.tenant);
    const user = useAppSelector((state) => state.userLogin.user);

    return (
        <Dropdown
            menu={{
                items: [
                    user
                        ? {
                              label: `${user.firstName} ${user.lastName}`,
                              icon: <FontAwesomeIcon icon={faUser} />,
                              key: "USER",
                          }
                        : null,
                    tenant
                        ? {
                              label: "User Profile",
                              icon: <FontAwesomeIcon icon={faIdCard} />,
                              key: "USER_PROFILE",
                              onClick: () => {
                                  history.push(AppPaths.TENANT_USER_PROFILE.replace(":tenant", tenant.name));
                              },
                          }
                        : null,
                    {
                        type: "divider",
                    },
                    {
                        label: "Logout",
                        icon: <FontAwesomeIcon icon={faSignOut} />,
                        key: "LOGOUT",
                        onClick: (e) => {
                            e.domEvent?.preventDefault && e.domEvent.preventDefault();
                            onLogout();
                        },
                    },
                ],
            }}
        >
            <Button type="text" size="small" icon={<FontAwesomeIcon icon={faUser} style={{ color: "var(--header-text)" }} />} />
        </Dropdown>
    );
}
